/* eslint-disable react/display-name */
import React from "react";
import styled from "styled-components";
import { HeaderProvider } from "../actions/headerContext";
import { useHeaderTitle } from "../actions/headerContext";
import { SidebarProvider, useSidebar } from "../contexts/SidebarContext";
import { MobileSidebar } from "./MobileSidebar";
import { useIsMobile } from "../hooks/useIsMobile";
import { THEME_MAP } from "../theme";

const defaultOptions = {};

export function Layout({
	header: Header,
	nav: Nav,
	content: Content,
	options: _options,
	...props
}) {
	const options = { ...defaultOptions, ..._options };

	return (
		<HeaderProvider>
			<SidebarProvider>
				<LayoutInner
					Header={Header}
					Nav={Nav}
					Content={Content}
					options={options}
					{...props}
				/>
			</SidebarProvider>
		</HeaderProvider>
	);
}

function LayoutInner({ Header, Nav, Content, options, ...props }) {
	const isMobile = useIsMobile();
	const { isOpen, close } = useSidebar();
	const dynamicTitle = useHeaderTitle();
	const pageTitle = dynamicTitle || options.title || "";

	return (
		<Container>
			{Nav && !isMobile && <Nav {...props} />}
			{Nav && isMobile && (
				<MobileSidebar isOpen={isOpen} onClose={close}>
					<Nav {...props} />
				</MobileSidebar>
			)}
			<div className="content-layout">
				{Header && <Header {...props} />}
				{pageTitle && <PageTitle>{pageTitle}</PageTitle>}
				{Content && <Content {...props} />}
			</div>
		</Container>
	);
}

const PageTitle = styled.h2`
	padding: 20px 24px 16px;
	font-weight: 500;
	font-size: 1.5rem;
	color: ${THEME_MAP["color-basic-900"]};

	@media (max-width: 767px) {
		padding: 16px 16px 12px;
		font-size: 1.25rem;
	}
`;

const Container = styled.div`
	min-height: 100vh;
	width: 100%;

	display: flex;
	/* we want the nav on the left */
	flex-direction: row;

	.content-layout {
		min-height: 100vh;
		height: 100%;
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		background: ${THEME_MAP["color-basic-200"]};
	}
`;

export function withLayout(Header) {
	return function (Nav) {
		return function (Content, options) {
			return (props) => (
				<Layout
					header={Header}
					nav={Nav}
					content={Content}
					{...props}
					options={options}
				/>
			);
		};
	};
}
